module.exports = __webpack_public_path__ + "static/media/lily-collins-win.d91634a9.jpg";